/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IncidentRecordDto } from './incidentRecordDto.schema';

export const CompleteIncidentRecord = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.lazy(() => IncidentRecordDto).optional()
});

export type CompleteIncidentRecord = zod.input<typeof CompleteIncidentRecord>;
export type CompleteIncidentRecordOutput = zod.output<typeof CompleteIncidentRecord>;
